module.exports = "<div class=\"deliverySaverComingSoon\">\r\n    <h1 class=\"deliverySaverComingSoon-title\"><wow-setting setting-group=\"DeliverySaver\" setting-name=\"ComingSoonTitle\"></wow-setting></h1>\r\n    <p class=\"deliverySaverComingSoon-text\"><wow-setting setting-group=\"DeliverySaver\" setting-name=\"ComingSoonText\"></wow-setting></p>\r\n    <a ui-sref=\"shop.myaccount.preferences\" class=\"button button--primary button--large\">\r\n        Update my account preferences&nbsp;<i class=\"iconww-ArrowRight\"></i>\r\n    </a>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/deliverysaver/comingsoon/delivery-saver-coming-soon.component.html
// module id = 361
// module chunks = 0 9